<template>
  <div class="product--card">
    <div class="content">
      <span class="icon">
        <i :class="`ra-icon--${product.icon}`" />
      </span>
      <div class="text">
        <h6>{{ product.label }}</h6>
        <p>{{ product.description }}</p>
      </div>
    </div>
    <div class="action">
      <template v-if="isProductAccessible">
        <el-button type="primary" size="medium" plain @click="goToProduct"
          >Explore</el-button
        >
      </template>
      <template v-else>
        <template v-if="userCan('auth', 'feature.saveorganisationfeature')">
          <el-button
            v-if="isVerifyIdCheck"
            class="info"
            type="text"
            size="medium"
            plain
            @click="goToOrganisationActivation"
            ><i class="ra-icon--info" /> Activate organisation
          </el-button>
          <el-button
            v-else
            type="primary"
            size="medium"
            plain
            @click="goToProduct"
            >Explore</el-button
          >
        </template>
        <template v-else>
          <el-tooltip
            effect="dark"
            content="Organisation has no access to this product."
            placement="top-start"
          >
            <el-button class="info" type="text" size="medium" plain>
              <i class="ra-icon--info" /> Contact admin</el-button
            >
          </el-tooltip>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { isOrganisationActive, isProductAccessible } from "@/lib/utils";

export default {
  name: "ProductCard",
  props: {
    product: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    isVerifyIdCheck() {
      return this.product.name.includes("verify") && !isOrganisationActive();
    },
    isProductAccessible() {
      return isProductAccessible(this.product.name);
    }
  },
  methods: {
    goToOrganisationActivation() {
      this.$router.push({ name: "organisation.index", hash: "#settings" });
    },
    goToProduct() {
      this.$router.push({ name: `${this.product.page}.index` });
    }
  }
};
</script>

<style lang="scss" scoped>
.product--card {
  background: #ffffff;
  box-shadow: 0 0 30px 0 rgb(82 63 105 / 7%);
  border-radius: 12px;
  padding: 25px;
  min-height: 120px;
  width: 100%;

  .content {
    display: flex;
    align-items: flex-start;
    width: 100%;

    .icon {
      background: var(--ra-red-primary);
      height: 36px;
      width: 36px;
      border-radius: 50px;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        font-size: 1rem;
        font-weight: 600;
        color: #fff;
      }
    }

    .text {
      width: calc(100% - 50px);
      margin-left: auto;

      h6 {
        font-size: 1.125rem;
        font-weight: 500;
        color: var(--ra-grey-primary);
        margin-bottom: 7px;
      }

      p {
        font-size: 0.825rem;
        line-height: 1.5;
        color: var(--ra-grey-tertiary);
      }
    }
  }

  .action {
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    position: relative;

    .info {
      color: var(--ra-grey-tertiary);

      i {
        font-size: 1rem;
        margin-right: 5px;
        color: var(--ra-red-primary);
      }
    }
  }

  @media (max-width: 600px) {
    margin-bottom: 20px;
  }
}
</style>
